import { gunzipSync, gzipSync, strFromU8, strToU8 } from 'fflate';

import { PreloadedDashboardData } from '../dashboard-grid.model';

const compressData = (data?: PreloadedDashboardData) => {
    if (!data) {
        console.error('Data not provided for compression.', data);
        return;
    }

    return Buffer.from(gzipSync(strToU8(JSON.stringify(data)))).toString('base64');
};

const decompressData = <T>(data?: string): T | undefined => {
    if (!data) {
        console.error('Data not provided for decompression.', data);
        return;
    }

    return JSON.parse(
        strFromU8(
            gunzipSync(
                Buffer.from(data, 'base64'), // Convert base64 to Uint8Array
            ),
        ),
    );
};

export { compressData, decompressData };
